import { FormDialog } from '@criteria-labs/react'
import { ProjectFile } from '../ProjectItem'
import { ProjectManager } from '../ProjectManager'
import { useProjectSelection } from '../selection/useProjectSelection'

export function ImportURLDialog({ open, onClose }: { open: boolean; onClose: (open: boolean) => void }) {
  const { selection, select } = useProjectSelection()
  return (
    <FormDialog
      open={open}
      onClose={onClose}
      title="Import a URL"
      submitActionTitle="Import"
      submittingActionTitle="Importing&hellip;"
      color="indigo"
      onSubmit={async ({ url }) => {
        const response = await fetch(url)
        if (!response.ok) {
          throw new Error(`The URL returned a ${response.status} status code`)
        }
        if (!response.body) {
          throw new Error('The URL did not contain any data')
        }

        const text = await response.text()
        const urlObject = new URL(url)
        const segments = urlObject.pathname.split('/')
        const name = segments.length > 0 ? segments[segments.length - 1] : ''

        const parentFolder = ProjectManager.shared().getNearestFolder(selection)
        ProjectManager.shared().createFileSync(parentFolder, name, text, (createdFile: ProjectFile) => {
          select(createdFile.path, true)
        })
      }}
      defaultValues={{ url: '' }}
      schema={{
        type: 'object',
        required: ['url'],
        properties: {
          url: { title: 'Enter a URL', type: 'string' }
        }
      }}
    />
  )
}
